<template>

  <span>
    <b-icon icon="arrow-clockwise" animation="spin" v-if="showOverlay" />
    <span class="alarmLetzerBesuchsbericht" v-if="alarm">
        <alarm-level-icon :alarm="alarm" />
    </span>
  </span>

</template>

<script>

    import axios from 'axios'
    axios.defaults.withCredentials = true
    import alarmLevelIcon from '@/components/layout/AlarmLevelIcon'

    export default {
      name: 'AlarmLetzterBesuchsbericht',
      components: {
        alarmLevelIcon,
      },
      props: ['customer'],
      data () {
        return {
          alarm: null,
          showOverlay: null,
        }
      },
      watch: {
        customer: function () {
            this.init()
        }
      },
      created () {
        this.init()
      },
      methods: {

        init: function () {

          // prüfe ob der AlarmLevel bereits im Customer gecacht ist
          if (this.customer && this.customer.alarmLevel) {
            this.showOverlay = false
            this.alarm = this.customer.alarmLevel
            return
          }

          this.showOverlay = true
          this.alarm = null
          if (this.customer) {

            const url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getAlarmLastBesuchsbericht'
            const params  = {
              customer_id: this.customer.id,
            }

            const that = this
            axios({
              method: 'GET',
              params: params,
              url: url,
            }).then((response) => {

              if (response.data.name) {
                that.alarm = response.data
                that.$emit('set-alarm', {
                  alarm:    that.alarm,
                  customer: that.customer,
                })
              }
              that.showOverlay = false

            }).catch(error => {
              console.log(error)
              that.showOverlay = false
            })

          }

        }, // end init

      }, // end methods

    }

</script>